import React, {Component} from 'react';
import PropTypes from "prop-types";
import {DataTable} from "react-data-components";
import ModalDeletePerson from './ModalDeletePerson';
import userImage from '../../../assets/img/128x128.jpg';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import api from '../../../utils/api';

class PeopleInstructors extends Component {
    state={
        columns: [],
        instructors: [...this.props.instructors],
        showingDeleteUser: false,
        deleteUserId: null
    };

    //Renders
    renderImg = (val, row) => {
        if(row.Profile){
            let avatar = userImage;
            if(row.Profile.image){
                if(row.Profile.image.indexOf('http') > -1){
                    avatar = row.Profile.image;
                }else{
                    avatar = api.makeFileURL(row.Profile.image, this.props.user.id);
                }
            }
            return (
                <img
                    className="chat-avatar"
                    src={avatar}
                    alt={row.Profile.name}
                />
            )
        }else{
            return (
                <img
                    className="chat-avatar"
                    src={userImage}
                    alt={row.Profile.name}
                />
            )
        }
    };


    renderActions = (val, row) => (
        <div className="dropdown">
            <a
                href="#"
                className="btn btn-default"
                data-toggle="dropdown"
                aria-expanded="false"
            >
                Actions <i className="zmdi zmdi-caret-down"/>
            </a>
            <ul className="dropdown-menu w-lg pull-right fixed-width-icons">
                <li>
                    <a role="button">
                        <i className="zmdi zmdi-undo"/>
                        Undo
                    </a>
                </li>
                {row.status == 'blocked' ?
                    <li>
                        <a role="button"
                           onClick={(e) => {
                               row.status = "approved";
                               this.props.updateCourseUser(row, this.props.user.id);
                           }}
                        >
                            <i className="zmdi zmdi-play"/>
                            Resume
                        </a>
                    </li>

                    :

                    <li>
                        <a role="button"
                           onClick={(e) => {
                               row.status = "blocked";
                               this.props.updateCourseUser(row, this.props.user.id);
                           }}
                        >
                            <i className="zmdi zmdi-pause"/>
                            Hold
                        </a>
                    </li>
                }
                <li>
                    <a
                        role="button"
                        onClick={()=>{this.setState({showingDeleteUser: true, deleteUserId: row.id})}}
                    >
                        <i className="zmdi zmdi-delete"/>
                        Delete
                    </a>
                </li>
            </ul>
        </div>
    );


    renderCourses = (val, row) => {


        return (
            <span>{row.Course.name}</span>
        )
    }

    renderReferrals = (val, row) => (
        <input
            type="number"
            className="form-control"
            defaultValue={row.referrals || 0}
            onChange={(e) => {
                e.preventDefault();
                row.referrals = e.target.value;
                this.props.updateCourseUser(row, this.props.user.id);
            }}
        />
    );

    renderDate = (val, row) => (
        <input
            type="date"
            className="form-control"
            value={val}
            onChange={(e) => {
                e.preventDefault();
                this.props.editAccessInstructor(e.target.value, row.id);
            }}
        />
    );

    renderStatus = (val, row) =>  {
        return (
            <span
                className={`label label-${
                    (row.status === 'blocked')
                        ? 'danger'
                        : (row.status === 'approved')
                        ? 'success'
                        : 'warning'
                    }
            `}
            >
            {row.status.toUpperCase()}
        </span>
        )
    }

    renderSelect = () => (
        <select
            onChange={(e) => {
                e.preventDefault();
                this.handleChangeSelect(e);
            }}
        >
            <option>All Instructors</option>
            <option>MCAT</option>
            <option>LSAT</option>
        </select>
    );

    //Actions
    handleChangeSelect = (e) => {
        if (e.target.value === 'All Instructors') {
          this.setState({instructors:  this.props.instructors});
        } else {
          this.setState({instructors:  this.props.instructors.filter(item=> item.courses=== e.target.value)});
        }
    };

    renderName = (val, row) => {
        return (
            <span>{row.Profile.name || row.Profile.email}</span>
        )
    }

    renderLastActive = (val, row) => {

        return (
            <span className="text-center">{moment(row.lastActive).format('MMM DD YYYY @ HH:mm:ss')}</span>
        )

    }

    //Lifecycle
    componentDidMount() {
        this.props.getInstructorsData();
        this.props.onLoadCourses(this.props.user.userId);
        this.props.getInstructors(this.props.user.id);
        this.setState({
            columns: [
                {title: '', className: 'sorting_1', render: this.renderImg},
                {title: 'Name', className: 'v-middle', render: this.renderName},
                {title: 'Status', prop: 'status', className: 'v-middle', render: this.renderStatus},
                {title: 'Last Active', className: 'v-middle', render: this.renderLastActive},
                {title: 'Access', className: 'v-middle', render: this.renderExpiry},
                {title: 'Referrals', className: 'v-middle', render: this.renderReferrals},
                {title: 'Courses', className: 'v-middle', render: this.renderCourses},
                {title: 'Actions', prop: 'id', className: 'v-middle', render: this.renderActions}
            ]
        })
    };

    componentWillReceiveProps(nextProps) {
        if (this.props.instructors !== nextProps.instructors) {
            this.setState({instructors: nextProps.instructors});
        }
    };

    updateExpiry = (d, courseUser) => {

        courseUser.expiry = d;
        this.props.updateCourseUser(courseUser, this.props.user.id);


    }

    renderExpiry = (val, row) => {
        return (
            <DatePicker
                selected={moment(row.expiry) || ''}
                onChange={(e) => this.updateExpiry(e, row)}
                className="form-control"
            />
        )
    }

    hideModalDelete = () => {
        this.setState({showingDeleteUser: false});
    }

    deleteUserConfirmation = () => {
        this.props.removeCourseUser(this.state.deleteUserId, this.props.user.id);
    }

    render() {

        let {instructors} = this.state;



        return (
            <div className="panel customPanel no-bg flat">
                    <div className="panel-body">
                        <h3 className="font-300 sm-top0">
                            Instructors Access Control
                        </h3>
                        <p>
                            This is where you can see all the instructors for each course and control their access
                        </p>

                        {
                            this.props &&
                            <ModalDeletePerson
                                hideModalDelete={this.hideModalDelete}
                                showDeleteUser={this.state.showingDeleteUser}
                                deleteUserConfirmation={this.deleteUserConfirmation}
                                userId={this.state.deleteUserId}
                            />

                        }

                        <div className="panel customPanel">
                            <div className="panel-heading border-bottom">
                                <div className="panel-control">
                                    {this.renderSelect()}
                                </div>
                                <h3 className="panel-title">
                                    Instructors
                                </h3>
                            </div>
                            <div className="panel-body">
                                <div className="table-responsive statistic-students table-admin">
                                    <DataTable
                                        keys="name"
                                        columns={this.state.columns}
                                        initialData={instructors}
                                        initialPageLength={10}
                                        initialSortBy={{ prop: 'Profile.name', order: 'descending' }}
                                        pageLengthOptions={[10, 25, 50, 100]}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        )
    }
}

PeopleInstructors.propTypes = {
    instructors: PropTypes.array,
    getInstructorsData: PropTypes.func.isRequired,
    instructorDelete: PropTypes.func,
    editCoursesInstructor: PropTypes.func,
    editAccessInstructor: PropTypes.func,
    editReferralsInstructor: PropTypes.func
};

export default PeopleInstructors;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/People/PeopleInstructors.js